import React, { useState } from 'react';
import { Button, Link } from '../ui';
import { useTranslation } from 'react-i18next';
import VerificationCode from '../VerificationCode/VerificationCode';
import { VerifyEmailDTO } from '../../store/auth/types';
import Loading from '../Loading/Loading';

export interface SendVerificationProps {
  verify_code_handler: (data: VerifyEmailDTO) => void;
  resend_handler: () => void;
  logout_handler: () => void;
  email: string;
  loading: boolean;
}

const SendEmailVerification: React.FC<SendVerificationProps> = (props) => {
  const { verify_code_handler, resend_handler, logout_handler, email, loading } = props;
  const { t, i18n } = useTranslation();

  const [verificationCode, setVerificationCode] = useState<string>('');

  if (loading) return <Loading />;

  return (
    <div>
      <h2 className="text-2xl mb-9 font-semibold text-gray-600">{t('Email verification')}</h2>
      <div className="flex flex-col gap-y-3">
        <VerificationCode email={email} onChange={(e) => setVerificationCode(e.target.value)} />
        <Button
          disabled={!verificationCode.length}
          className="w-full mt-1"
          onClick={() => verify_code_handler({ code: verificationCode })}
        >
          {t('Verify code')}
        </Button>
      </div>
      <div className="flex justify-between mt-7">
        <Link onClick={() => resend_handler()} className="font-semibold text-xs cursor-pointer">
          {t('Resend code')}
        </Link>
        <Link onClick={logout_handler} className="font-semibold text-xs cursor-pointer">
          {t('Logout')}
        </Link>
      </div>
    </div>
  );
};

export default SendEmailVerification;
